export default "__VITE_ASSET__cRlDV5fn__"